enum LoadCondition {
  Laden = "Laden",
  Ballast = "Ballast",
}

export default LoadCondition;
